<app-closeable-dialog-title
  [allowMaximize]="false"
  title="Screening result export">
</app-closeable-dialog-title>

<div mat-dialog-content>

  <form [formGroup]="form" (ngSubmit)="export()">
    <mat-form-field class="full-width">
      <mat-label>Export type</mat-label>
      <mat-select formControlName="fileformat" required>
        @for (option of fileFormat; track option) {
          <mat-option [value]="option.value">{{ option.viewValue }}</mat-option>
        }
      </mat-select>
      @if (form.get('fileformat')?.hasError('required')) {
        <mat-error>Please choose an file format</mat-error>
      }
      <mat-hint>This setting is not saved and only valid in this session</mat-hint>
    </mat-form-field>


    <mat-form-field class="full-width">
      <mat-label>Paper Filter Settings</mat-label>
      <mat-select formControlName="paperFilterSelect" required>
        @for (option of options; track option) {
          <mat-option [value]="option.value">{{ option.viewValue }}</mat-option>
        }
      </mat-select>
      @if (form.get('paperFilterSelect')?.hasError('required')) {
        <mat-error>Please choose an FilterType</mat-error>
      }
      <mat-hint>This setting is not saved and only valid in this session</mat-hint>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions class="actions" align="end">
  <button mat-button class="save-btn" [disabled]="form.invalid" (click)="export()">Export</button>
</div>
